import React from 'react';
import { Tooltip } from 'react-tooltip';

const statusDescriptions = {
  Uploaded: 'File is ready for conversion',
  Converting: 'File is currently being converted',
  Converted: 'Conversion is complete, file is ready for download',
  Deleted: 'File has been downloaded and deleted from our servers',
  Error: 'An error occurred during conversion'
};

const FileStatusIndicator = ({ status, progress }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'Uploaded': return 'bg-blue-500';
      case 'Converting': return 'bg-yellow-500';
      case 'Converted': return 'bg-green-500';
      case 'Deleted': return 'bg-gray-500';
      case 'Error': return 'bg-red-500';
      default: return 'bg-gray-300';
    }
  };

  const tooltipContent = statusDescriptions[status] || `Status: ${status}`;
  const showProgress = status === 'Converting' && progress !== undefined;

  return (
    <div className="relative flex items-center">
      <div 
        className="w-3 h-3 rounded-full bg-gray-200 relative overflow-hidden"
        data-tooltip-id={`status-tooltip-${status}`}
        data-tooltip-content={tooltipContent}
      >
        <div 
          className={`absolute top-0 left-0 bottom-0 right-0 transition-all duration-300 ease-in-out ${getStatusColor()}`}
          style={{ 
            transform: showProgress ? `scaleX(${progress / 100})` : 'scaleX(1)',
            transformOrigin: 'left'
          }}
        ></div>
      </div>
      <Tooltip id={`status-tooltip-${status}`} />
    </div>
  );
};

export default FileStatusIndicator;